import { Button } from 'braid-design-system';
import type React from 'react';
import { useStores } from 'src/utils/hooks/useStores';
import { observer } from 'mobx-react';
import type { FilterFns } from '../../../components/app/FilterSideBar/useFilters';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import { FilterClearButton } from '../FilterClearButton/FilterClearButton';

export interface StickyButtonsProps {
  onClose(): void;
  resetFilters: FilterFns['resetFilters'];
  shouldShowClearFilterButton: boolean;
}

export const StickyButtons: React.FC<StickyButtonsProps> = observer(
  ({ onClose, resetFilters, shouldShowClearFilterButton }) => {
    const { t } = useTranslations(translations);
    const { jobApplicationStore } = useStores();
    const { currentTotalOfJobApplications } = jobApplicationStore;

    return (
      <>
        <Button type="button" onClick={onClose}>
          {t('View candidateCount candidate/s', {
            candidateCount: currentTotalOfJobApplications,
          })}
        </Button>
        {shouldShowClearFilterButton ? (
          <FilterClearButton
            resetFilters={resetFilters}
            bleed={false}
            showIcon={false}
          />
        ) : null}
      </>
    );
  },
);
